import { FrameName } from "../config";
import AbstractPoiTileEntity from "./AbstractPoiTileEntity";

class TerraceGardens3PoiTileEntity extends AbstractPoiTileEntity {
	public static readonly frameName = FrameName.TERRACE_GARDENS3;
}

export default TerraceGardens3PoiTileEntity;
